import cn from "classnames";
import { PageBreadcrumbs } from "~/components/Page";
import { Skeleton } from "~/components/ui/skeleton";
import styles from "./styles.module.scss";

const FieldSkeleton = () => (
  <div className="space-y-2">
    <Skeleton className="h-3.5 w-28" />
    <Skeleton className="h-10 w-full" />
  </div>
);

const UploadPageSkeleton = () => (
  <>
    <PageBreadcrumbs>
      <Skeleton className="h-4 w-72" />
    </PageBreadcrumbs>

    <div className={cn([styles.uploadForm, "h-full w-full"])}>
      <div className="flex h-full w-full flex-col xl:flex-row">
        <div className={cn("w-full xl:w-1/3 2xl:w-1/4", styles.leftCol)}>
          <Skeleton className="h-72 w-full rounded-2xl xl:h-[500px]" />
        </div>

        <div className={cn("w-full xl:w-2/3 2xl:w-1/2", styles.formContainer)}>
          <div className="mb-6 space-y-6">
            <FieldSkeleton />
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              {Array.from({ length: 6 }).map((_, i) => (
                <FieldSkeleton key={`upload-skeleton-field-${i}`} />
              ))}
            </div>
            <div className="space-y-2">
              <Skeleton className="h-3.5 w-28" />
              <Skeleton className="h-24 w-full" />
            </div>
          </div>
          <div className="flex gap-4">
            <Skeleton className="h-10 w-40" />
            <Skeleton className="h-10 w-44" />
          </div>
        </div>
      </div>
    </div>
  </>
);

export default UploadPageSkeleton;
